// extracted by mini-css-extract-plugin
export default {"position_labels":"styles_position_labels__rpfKg","label":"styles_label__vF6II"};